import { IOModel } from "pages/Insurance-Info/configuration";
const { createSlice } = require("@reduxjs/toolkit");

const formDataInitialState = { formData: IOModel };
const formDataSlice = createSlice({
  name: "formData",
  initialState: formDataInitialState,
  reducers: {
    editFormData(state: any, action: any) {
      // let newData = { ...action.payload };
      // state.formData = newData;
      state.formData = action.payload;
    },
  },
});

export const formDataActions = formDataSlice.actions;

export default formDataSlice.reducer;
